import { useEffect, useState } from 'react'
import {
  getLoadingFiles,
  subscribeToLoadingFiles,
  type UploadingFile,
} from '../services/loading-files-service'

/**
 * Hook to subscribe to in-progress files state (filepool uploads + RLCP).
 * Only use in components that need to display upload progress.
 * This will cause re-renders when loadingFiles changes.
 *
 * @returns Array of currently loading files with fileName and fileType
 */
export function useUploadingFiles(): UploadingFile[] {
  const [uploadingFiles, setUploadingFiles] = useState<UploadingFile[]>(getLoadingFiles)

  useEffect(() => {
    const unsubscribe = subscribeToLoadingFiles(() => {
      setUploadingFiles(getLoadingFiles())
    })
    return unsubscribe
  }, [])

  return uploadingFiles
}
